import RHLogo from '../images/whiteRamaLogo.png';
import Instagram from '../images/instagramIcon.png';
import Facebook from '../images/facebookIcon.png';
import YouTube from '../images/youtubeIcon.png';
import LinkedIn from '../images/linkedinIcon.png';
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from 'axios';

interface SpecialityItem {
  id: number;
  link: string;
  title: {
    rendered: string;
  };
}

const EMERGENCY_NUMBERS = [
    { id: 3, name: "Bagpat",    number: "+91 9520882969" },
      { id: 2, name: "Hapur",     number: "+91 7065000999" },
       { id: 5, name: "Lakhanpur", number: "+91 7081570570" },
       { id: 4, name: "Mandhana",  number: "+91 7310473105" },
        { id: 6, name: "Mathura", number: "+91 9520750520" },
      { id: 1, name: "Noida",     number: "+91 9711879898" },


  
 
 

];

const HOSPITALS = [
  { id: 6, name: "Lakhanpur", link: "https://ramahospital.com/rama-hospital-lakhanpur/" },
  { id: 5, name: "Mandhana",  link: "https://ramahospital.com/rama-hospital-mandhana/" },
  { id: 4, name: "Baghpat",   link: "https://ramahospital.com/rama-hospital-baghpat/" },
  { id: 3, name: "Hapur",     link: "https://ramahospital.com/rama-hospital-hapur/" },
  { id: 2, name: "Mathura",   link: "https://ramahospital.com/rama-hospital-mathura/" },
  { id: 1, name: "Noida",     link: "https://ramahospital.com/rama-hospital-noida/" },
];

const routeMap = {
  "Privacy Policy": "/privacy",
  "Terms & Condition": "/terms_conditions",
  "Refund & Cancellation": "/refund_and_cancellation",
  "Grievance Redressal Policy": "/grievance",
  "Recaptcha Policy": "/recaptcha",
  "Disclaimer": "/disclaimer",
} as const;

interface Policy {
  policyId: string;
  policyName: keyof typeof routeMap;
}

export default function Footer() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const [policyContent, setPolicyContent] = useState<Policy[]>([]);
  const [loading, setLoading] = useState(true);
  const [speciality, setSpeciality] = useState<SpecialityItem[]>([]);
  const [isEmergencyOpen, setIsEmergencyOpen] = useState(false);

  useEffect(() => {
    const fetchspecialization = async () => {
      try {
        const res = await axios.get(
          `https://ramahospital.com/wp-json/wp/v2/pages?parent=274&per_page=100&_fields=id,title,link`
        );
        setSpeciality(res.data);
      } catch (err) {
        console.error("Error fetching speciality:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchspecialization();
  }, []);

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/GetPolicy`
        );
        setPolicyContent(res.data);
      } catch (err) {
        console.error("Error fetching policy:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPolicy();
  }, []);

  const handleNavigation = () => {
    if (token) {
      navigate("/profile");
    } else {
      navigate("/login");
    }
  };

  return (
    <footer className="bg-[#E8F7F4] pt-6 flex flex-col items-center mt-5">

      {/* Main Footer Content */}
      <div className="w-full max-w-[1200px] px-4 sm:px-6 flex flex-col lg:flex-row gap-8 mb-10">

        {/* Left: 4-column grid */}
        <div className="flex-1 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-8 pt-5 text-sm">

          {/* For Patients */}
          <div>
            <h4 className="font-bold mb-3 text-[#1EAA96] text-base sm:text-lg">For Patients</h4>
            <ul className="space-y-2 text-[#3C3C3C]">
              <li className="cursor-pointer hover:text-[#1EAA96] transition-colors">
                <Link to="/">Find Doctors</Link>
              </li>
              <li className="cursor-pointer hover:text-[#1EAA96] transition-colors">
                <Link to="/">Book Appointment</Link>
              </li>
              <li className="cursor-pointer hover:text-[#1EAA96] transition-colors">
                <a href="https://ramahospital.com/book-an-appointment/" target="" rel="noopener noreferrer">
                  Expert Opinion
                </a>
              </li>
              <li className="cursor-pointer hover:text-[#1EAA96] transition-colors">
                <a href="https://ramahospital.com/health-check-up/" target="" rel="noopener noreferrer">
                  Book Health Checkup
                </a>
              </li>
              {policyContent.map((policy) => {
                const route = routeMap[policy.policyName] || "#";
                return (
                  <li key={policy.policyId} className="cursor-pointer hover:text-[#1EAA96] transition-colors">
                    <Link to={route}>{policy.policyName}</Link>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Specialities */}
          <div>
            <h4 className="font-bold mb-3 text-[#1EAA96] text-base sm:text-lg">Specialities</h4>
            <ul className="space-y-2 text-[#3C3C3C]">
              {loading ? (
                <li className="text-gray-400">Loading...</li>
              ) : (
                speciality.slice(0, 8).map((item) => (
                  <li key={item.id} className="cursor-pointer hover:text-[#1EAA96] transition-colors">
                    <a
                      href={item.link}
                   
                      rel="noopener noreferrer"
                      className="hover:underline"
                    >
                      {item.title.rendered}
                    </a>
                  </li>
                ))
              )}
              <li className="cursor-pointer font-semibold underline text-[#1EAA96]">
                <a href="https://ramahospital.com/specialities/" rel="noopener noreferrer">
                  View all
                </a>
              </li>
            </ul>
          </div>

          {/* Our Hospitals */}
          <div>
            <h4 className="font-bold mb-3 text-[#1EAA96] text-base sm:text-lg">Our Hospitals</h4>
            <ul className="space-y-2 text-[#3C3C3C]">
              {HOSPITALS.map((hospital) => (
                <li key={hospital.id} className="cursor-pointer hover:text-[#1EAA96] transition-colors">
                  <a href={hospital.link}  rel="noopener noreferrer">
                    Rama Hospital, {hospital.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Business */}
          <div>
            <h4 className="font-bold mb-3 text-[#1EAA96] text-base sm:text-lg">Our Business</h4>
            <ul className="space-y-2 text-[#3C3C3C]">
              <li className="hover:text-[#1EAA96] transition-colors"><a href="https://ramahospital.com/about-us/"  rel="noopener noreferrer">About us</a></li>
              <li className="hover:text-[#1EAA96] transition-colors"><a href="https://ramahospital.com/our-management/"  rel="noopener noreferrer">Management</a></li>
              <li className="hover:text-[#1EAA96] transition-colors"><a href="https://ramahospital.com/international-patients/"  rel="noopener noreferrer">International Patients</a></li>
              <li className="hover:text-[#1EAA96] transition-colors"><a href="https://ramahospital.com/news-events/" rel="noopener noreferrer">News & Events</a></li>
              <li className="hover:text-[#1EAA96] transition-colors"><a href="https://ramahospital.com/blogs-articles/"  rel="noopener noreferrer">Blogs</a></li>
              <li className="hover:text-[#1EAA96] transition-colors"><a href="https://ramahospital.com/careers/"  rel="noopener noreferrer">Careers</a></li>
              <li className="hover:text-[#1EAA96] transition-colors"><a href="https://ramahospital.com/contact/"  rel="noopener noreferrer">Contact Us</a></li>
              <li className="hover:text-[#1EAA96] transition-colors"><a href="https://ramahospital.com/sitemap.xml"  rel="noopener noreferrer">Sitemap</a></li>
            </ul>
          </div>
        </div>

        {/* Right: Emergency + Call + Security */}
        <div className="w-full lg:w-[300px] flex flex-col items-stretch gap-4 pt-5">

          {/* Emergency Card — tap on mobile, hover on desktop */}
          <div className="relative w-full group">

            {/* Dropdown — hover on desktop, toggle on mobile */}
            <div
              className={`
                absolute bottom-full left-0 w-full overflow-hidden rounded-lg
                bg-[#b32626] shadow-2xl z-50 transition-all duration-300 ease-in-out
                ${isEmergencyOpen ? 'max-h-96 py-3 mb-2' : 'max-h-0 py-0'}
                lg:max-h-0 lg:py-0 lg:mb-0
                lg:group-hover:max-h-96 lg:group-hover:py-3 lg:group-hover:mb-2
              `}
            >
              {EMERGENCY_NUMBERS.map((item) => (
                <a
                  key={item.id}
                  href={`tel:${item.number.replace(/\s/g, "")}`}
                  className="flex items-center justify-between px-4 py-2.5 text-white text-sm border-b border-red-400 last:border-b-0 hover:bg-red-700 transition-colors"
                >
                  <span className="font-medium">{item.name}:</span>
                  <span className="font-bold">{item.number}</span>
                </a>
              ))}
            </div>

            {/* Card trigger */}
            <div
              className="flex gap-4 w-full bg-[#b32626] text-white rounded-lg px-4 py-3 shadow-md transition-all duration-300 cursor-pointer hover:bg-red-700 active:bg-red-800"
              onClick={() => setIsEmergencyOpen((prev) => !prev)}
            >
              <svg aria-hidden="true" className="w-10 h-10 fill-white flex-shrink-0" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
                <path d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z" />
              </svg>
              <div className="flex flex-col justify-center">
                <p className="text-sm opacity-80">
                  {/* hint changes based on device */}
                  <span className="lg:hidden">{isEmergencyOpen ? 'Tap to close' : 'Tap to view'}</span>
                  <span className="hidden lg:inline">Hover over me</span>
                </p>
                <p className="text-lg font-bold leading-tight">Emergency nos.</p>
              </div>
            </div>
          </div>

          {/* Book Appointment Call */}
          <a
            href="tel:+917302991952"
            className="flex gap-4 w-full bg-[#1eaa96] text-white rounded-lg px-4 py-3 shadow-md hover:bg-[#189b89] active:bg-[#157f6e] transition-all duration-300 cursor-pointer"
          >
            <svg
              aria-hidden="true"
              className="w-10 h-10 fill-white flex-shrink-0"
              viewBox="0 0 448 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"/>
            </svg>
            <div className="flex flex-col justify-center">
              <p className="text-sm opacity-80">Book Appointment</p>
              <p className="text-lg font-bold leading-tight">+91 73029 91952</p>
            </div>
          </a>

          {/* Security Badge */}
          <div className="mt-1">
            <span id="siteseal">
              <script async type="text/javascript" src="https://seal.godaddy.com/getSealBasic?sealID=Yps7COxQE8RLf698TKXZRdkjuZc2bmZxcFxZ2PhbF2ZFpxZQQv09CWOel4Bb"></script>
            </span>
          </div>
        </div>
      </div>

      {/* Bottom Copyright Bar */}
     {/* Copyright + Technology Partner — together, no gap */}
<div className="flex flex-col p-5 sm:flex-row sm:items-center bg-[#1eaa96] justify-center  text-white w-full sm:divide-x sm:divide-white/30 text-center sm:text-left text-xs sm:text-sm flex-shrink-0">
  
  {/* Copyright */}
  <div className="sm:pr-3 leading-relaxed">
    © {new Date().getFullYear()}{' '}
    <a
      href="https://www.ramahospital.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="font-semibold text-[#cce8ff] underline hover:no-underline"
    >
      Rama Hospital
    </a>
    . Crafted with{' '}
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red" width="14" height="14" className="inline animate-pulse align-middle">
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
    </svg>
    {' '}and Driven by Care.
  </div>

  {/* Technology Partner */}
  <div className="sm:pl-3 leading-relaxed">
    Technology Partner:{' '}
    <a
      href="https://rcsglobal.co.in/"
      target="_blank"
      rel="noopener noreferrer"
      className="font-semibold underline text-[#cce8ff] hover:no-underline"
    >
      RCS Global
    </a>
  </div>



        {/* Social Icons */}
        <div className="flex items-center gap-2 flex-shrink-0 ml-28 ">
          <img
            src={Instagram}
            alt="Instagram"
            className="h-7 w-7 cursor-pointer bg-white rounded-full p-1 hover:opacity-80 transition-opacity"
            onClick={() => window.open("https://www.instagram.com/ramahospital_rh/", "_blank")}
          />
          <img
            src={Facebook}
            alt="Facebook"
            className="h-7 w-7 cursor-pointer bg-white rounded-full p-1 hover:opacity-80 transition-opacity"
            onClick={() => window.open("https://www.facebook.com/RamaHospitalNoida/", "_blank")}
          />
          <img
            src={YouTube}
            alt="YouTube"
            className="h-7 w-7 cursor-pointer bg-white rounded-full p-1 hover:opacity-80 transition-opacity"
            onClick={() => window.open("https://www.youtube.com/@RamaHospital-RH/", "_blank")}
          />
          <img
            src={LinkedIn}
            alt="LinkedIn"
            className="h-7 w-7 cursor-pointer bg-white rounded-full p-1 hover:opacity-80 transition-opacity"
            onClick={() => window.open("https://www.linkedin.com/company/ramahospital", "_blank")}
          />
        </div>
      </div>

    </footer>
  );
}